module.exports = "../../static/fonts/Lato-BoldItalic.1ba4767.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-BoldItalic.ttf
// module id = 918
// module chunks = 2